<template>
    <cl-form :model="datas" :fields="fields" :btnDoSubmit="doSubmit" :pageload="pageload"
             :btnDoReset="addOrEdit" :btnShowCancal="false">
        <cl-form-row>
            <el-input ref="content" slot="content" v-model="datas.content" type="textarea"
                      :autosize="{minRows: 25,maxRows: 25}" placeholder="请输入内容"></el-input>
        </cl-form-row>
    </cl-form>
</template>
<script>
    export default {
        data() {
            return {
                openType: '',
                paramId: '',
                pageload: true,
                fields: {
                    row1: [{
                        label: '参数内容',
                        name: 'content',
                        span: 24,
                        rules: [{
                            required: true,
                            message: '参数内容不能为空',
                            trigger: 'blur'
                        }]
                    }]
                },
                datas: {
                    content: '',
                    addTime: ''
                },
            }
        },
        methods: {
            //新增、修改、重置
            addOrEdit() {
                this.request.get('/bigdata-visual/modelData/sysParam/page').then((res) => {
                    if (res.status == 1) {
                        const dataList = res.data;
                        if (dataList.length > 0) {
                            const data = dataList[0];
                            this.paramId = data.paramId;
                            for (let key in this.datas) {
                                if (!data[key]) {
                                    this.datas[key] = ''
                                } else {
                                    this.datas[key] = data[key]
                                }
                            }
                        }
                    } else {
                        this.$message.error("获取数据失败 ！");
                    }
                })

            },
            //编辑新增
            doSubmit() {
                if (this.paramId != null && this.paramId != "") {
                    this.pageload = true;
                    this.request.put("/bigdata-visual/modelData/sysParam/" + this.paramId, this.datas)
                        .then(res => {
                            if (res.status == 1) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.addOrEdit();
                            } else {
                                this.$message.error("操作失败 ！");
                            }
                            this.pageload = false;
                        });
                } else {
                    this.pageload = true;
                    this.request.post("/bigdata-visual/modelData/sysParam", this.datas)
                        .then(res => {
                            if (res.status == 1) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.addOrEdit();
                            } else {
                                this.$message.error("操作失败 ！");
                            }
                            this.pageload = false;
                        });
                }
            },
        },

        created: function () {
            this.pageload = false;
            this.addOrEdit();
        }
    }
</script>
